<template>
	<div class="v-card">
		<h3 v-if="tooltip.length === 0 && this.header?.length">
			{{ this.header }}
		</h3>
		<div v-else class="d-flex align-items-center">
			<h3>{{ this.header }}</h3>
			<span class="p-2" v-if="tooltip?.length">
				<i class="fa-regular fa-circle-question" @mouseover="tooltipState = true" @mouseleave="tooltipState = false"></i>
				<div class="tooltip" :class="tooltipState ? 'tooltip--show' : 'tooltip--hide'">{{ this.tooltip }}</div>
			</span>
		</div>
		<slot></slot>
	</div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
	name: "VCard",
	props: {
		header: {
			type: String,
			required: false,
			default: '',
		},
		tooltip: {
			type: String,
			required: false,
			default: '',
		}
	},
	data() {
		return {
			tooltipState: false,
		}
	}
});
</script>

<style scoped>
</style>
